module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_i"
    }
  }, [_c('p', {
    staticClass: "fmhead"
  }, [_vm._v("PRAISE FOR JACK HIGGINS AND HIS BESTSELLING NOVELS …")]), _vm._v(" "), _c('p', {
    staticClass: "fmhead1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ANGEL OF DEATH")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Jack Higgins’s electrifying bestseller—a mysterious terrorist group plots an assassination that will plunge Ireland into civil war …")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“Pulsing excitement … Higgins makes the pages fly.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("—New York Daily News")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“Jack Higgins has a new thriller, and like its long list of predecessors, it’s a terrific read.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—Associated Press")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“An exciting yarn … hurtles from one thrill to the next.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("—Publishers Weekly")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“As always with Higgins, the action never stops.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("—San, Francisco Examiner")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“A crackling good read … A thrilling confrontation … Jack Higgins has been writing page-turners for more than thirty years now, and with "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Angel of Death")]), _vm._v(" he comes through with another top-drawer thriller.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("—Virginian Pilot")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“A page-turner … an exciting read that will surely become a bestseller. Higgins once again has pulled it off.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("—The Chattanooga Free Press")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“A powerful novel crafted by a master of the game. In "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Angel of Death,")]), _vm._v(" Jack Higgins once again proves that he is on par with the best thriller writers of the day.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("—Back Channels")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“A gripping story without a single dead spot.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("—St. Petersburg Times")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“A convincing scenario … Another four-star thriller.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("—Dayton Daily News")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“Superb.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("—Minneapolis Star Tribune")])])]), _c('p', {
    staticClass: "fmhead1"
  }, [_c('a', {
    attrs: {
      "id": "page_i"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ON DANGEROUS GROUND")])])]), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Jack Higgins’s explosive thriller—the desperate search for a secret document that could change the fate of Hong Kong, China, and the world …")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“It’s a whirlwind of action, with a hero (Sean Dillon) who can out-Bond old James with one hand tied behind his back … It’s told in the author’s best style, with never a pause for breath.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("—New York Times Book Review")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“Engaging … Jack Higgins knows how to entertain, and entertain he does with "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("On Dangerous Ground.”")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("—Baton Rouge Magazine")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“This tale moves with a brisk and heady pace.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("—Roanoke Times & World News")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“A powerhouse tale of action and adventure.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("—Tampa Tribune-Times")])]), _vm._v(" "), _c('p', {
    staticClass: "fmhead1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SHEBA")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("His most powerful novel of Nazi intrigue—the shattering story of an archaeologist who discovers a legendary temple … and a Nazi plot to turn the landmark into Hitler’s secret stronghold.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“A seasoned pro … Mr. Higgins knows how to tell a story!”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("—New York Times Book Review")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“When it comes to thriller writers, one name stands well above the crowd—Jack Higgins.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—Associated Press")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“The master’s master of spycraft storytelling.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—UPI")])]), _c('p', {
    staticClass: "fmhead1"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("THUNDER POINT")])])]), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The shattering bestseller about the search for Martin Bormann’s missing files—in a sunken U-boat on the bottom of the Caribbean…")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“Dramatic … authentic … one of the author’s best.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("—New York Times")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“A rollicking adventure that twists and turns …”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("—San Diego Union-Tribune")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“As in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Eagle Has Landed,")]), _vm._v(" Higgins builds his plot around an event that was widely conjectured at the end of World War II—that Martin Bormann escaped Adolf Hitler’s bunker in Berlin … Gripping.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("—Houston Chronicle")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“Relentlessly paced … It’s a thriller all the way. Explosive, sinister, revealing … superb reading.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("—Macon Beacon")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“Gripping … believable … fast-paced … continuous action.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("—Washington Post Book World")])]), _vm._v(" "), _c('p', {
    staticClass: "fmhead1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("EYE OF THE STORM")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("A duel between two masters of espionage culminates in an attempted mortar attack on the British war cabinet—in this shocking thriller that blends fact and fiction …")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“A heart-stopping cat-and-mouse game … spectacular and surprising.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("—Abilene Reporter-News")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“A riveting story … as current as today’s headlines.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("—Columbia (SC) State")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“Razor-edged … "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Eye of the Storm")]), _vm._v(" will give you an adrenaline high. It’s a winner.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("—Tulsa World")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“When the final showdown looms, you can almost hear the clock ticking.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("—Lexington Herald-Ledger")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("“Will leave readers happily breathless.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("—Kirkus Reviews")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4e92ad0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/01_Praise.vue
// module id = 57
// module chunks = 0